import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

import moment from "moment";

export const FILTER__FORM_FIELDS_GLOBAL = {
    businessArea: "",
    searchByValue: ""
}

export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(
            endpoint.academic_career.getAllActive,
            "academicCareerDispValue",
            "academicCareerDispValue"
        ),
        dropdownMapping(
            endpoint.groupCode.getAllActive,
            "groupCodeDispValue",
            "groupCodeDispValue"
        ),
        dropdownMapping(
            endpoint.companyCode.getAllActive,
            "companyCodeDispValue",
            "companyCodeDispValue"
        ),
        dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "businessAreaDispValue",
            "businessAreaDesc"
        ),
        dropdownMapping(endpoint?.businessUnitType?.getAllBusinessUnitType, 'businessUnitTypeDispValue', 'id'),
    ]);
    return {
        academicCareer: dropdown[0],
        businessGroup: dropdown[1],
        companyCode: dropdown[2],
        businessArea: dropdown[3],
        branchType: dropdown[4],
    };
}

export const newRow = {
    businessGroup: "",
    businessArea: "",
    companyCode: "",
    branchType: "",
    academicCareer: "",
    effectiveDate: "",
    submissionDays: "",
    approvalDays: "",
    status: "ACTIVE"
}

export const getFormattedDate = (date) => date ? moment(date).format("DD MMM YYYY") : '-';

export const getCreateUpdateReqBody = (rowData, isBranchLevelConfig) => {
    const { branchType, businessArea} = rowData;
    const row = updateRequest(rowData);
    const { businessGroup, companyCode, academicCareer, effectiveDate, submissionDays, approvalDays, bounceDays, status } = row;
    return {
        businessGroup,
        businessArea: isBranchLevelConfig ? businessArea?.label : "ALL",
        companyCode,
        branchType: branchType?.label,
        academicCareer,
        effectiveDate: effectiveDate ? moment(effectiveDate).format("YYYY-MM-DD") : "",
        submissionDays,
        approvalDays,
        bounceDays,
        status
    }
}

export const getUpdatedData = (resp, dropdowns) => {
    const updatedData = resp?.data?.cashControlConfigList?.map(({
        businessGroup,
        businessArea,
        companyCode,
        branchType,
        academicCareer,
        ...rest
    }) => ({
        ...rest,
        businessGroup: dropdowns?.businessGroup?.find(bg => bg?.value == businessGroup),
        businessArea: dropdowns?.businessArea?.find(bu => bu?.value == businessArea),
        companyCode: dropdowns?.companyCode?.find(co => co?.value == companyCode),
        branchType: dropdowns?.branchType?.find(bt => bt?.label == branchType),
        academicCareer: dropdowns?.academicCareer?.find(ac => ac?.value == academicCareer)
    }));
    return updatedData;
}

